import type { FaireProductEntity } from "../../entity_types/product";

export const p_s2qycaaa74: FaireProductEntity = {
  token: "p_s2qycaaa74",
  type: "product",
  name: "Embroidered California Poppies - Brushed Cotton Snap Hat",
  brandToken: "b_9ha1ebi2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b0133949e814391f622293041e40ae39c79d22f55d83f76ae8be739a82d5bf74.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67cb6e10a0b1e1ada66f5e4514ccdecfa9db87089545566bae70a6c0f96def65.jpeg",
    "https://cdn.faire.com/fastly/b263a1c91bb4250cd62516e0c5f86588ad5cd4535c9066ee9bee84129855d68f.jpeg",
    "https://cdn.faire.com/fastly/4923c69e428567cdd439d8af1cbd66b2645e8c8e6d308a472d7943202289266f.jpeg",
    "https://cdn.faire.com/fastly/1b6524e63312c393bba6bf8d98321f4c90f0c79f9fcddc8cb753f125d3341ae9.jpeg",
  ],
  priceDollars: 26.33,
  description:
    "\nEmbroidered California Poppy 5 panel hats are all you need for your next California road trip. I hand drew each California Poppy and these are embroidered right in the back of the shop. I could wear this hat every day and be happy about it.\n\nFeatures:\n\n-Made from 100% Brushed Twill Cotton\n\n-Adjustable snap back\n\n-One Size Fits Most (58cm)\n\n-Hats are imported but they are embroidered in house to order at the shop\n\nYour order is crafted just for you, so it takes a little longer to arrive—but it's worth the wait! By choosing made-to-order, you're helping us cut down on waste, so thanks for shopping smart!\n",
  tags: [],
  msrpDollars: 52.66,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:26.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
